import FirstIcon from "../../images/Svg/Q1.svg";
import SecondIcon from "../../images/Svg/Q2.svg";
import ThirdIcon from "../../images/Svg/Q3.svg";

const data = [
  {
    id: 1,
    icon: FirstIcon,
    title: "Support for Text on Twitter",
    title2: "",
    text: "",
  },
  {
    id: 2,
    icon: SecondIcon,
    title: "Support for Images on Twitter",
    title2: "",
    text: "",
  },
  {
    id: 3,
    icon: ThirdIcon,
    title: "Support for videos.",
    title2:
      " API support for social media platforms: Facebook, Instagram, Youtube.",
    text: "coming soon",
  },
];

export default data;
